const StudentLoginPage = () => import(/* webpackChunkName: "StudentLoginPage" */ '../student/login/StudentLoginPage.vue');
// import StudentLoginPage from '../student/login/StudentLoginPage.vue';
const TestUserStudentLoginPage = () => import(/* webpackChunkName: "TestUserStudentLoginPage" */ '../student/login/TestUserStudentLoginPage.vue');
// import TestUserStudentLoginPage from '../student/login/TestUserStudentLoginPage.vue';

const StudentInfoInputMain = () => import(/* webpackChunkName: "StudentInfoInputMain" */ '../student/info/StudentInfoInputMain.vue');
// import StudentInfoInputMain from '../student/info/StudentInfoInputMain.vue';

const StudentLineRegistAfterPage = () => import(/* webpackChunkName: "StudentLineRegistAfterPage" */ '../student/register/StudentLineRegistAfterPage.vue');
// import StudentLineRegistAfterPage from '../student/register/StudentLineRegistAfterPage.vue';

const StudentDashBoardPage = () => import(/* webpackChunkName: "StudentDashBoardPage" */ '../student/dashboard/StudentDashBoardPage.vue');
// import StudentDashBoardPage from '../student/dashboard/StudentDashBoardPage.vue';

const StudentLessonListPage = () => import(/* webpackChunkName: "StudentLessonListPage" */ '../student/lesson_reservation/StudentLessonListPage.vue');
// import StudentLessonListPage from '../student/lesson_reservation/StudentLessonListPage.vue';
const StudentLessonListDaPage = () => import(/* webpackChunkName: "StudentLessonListDaPage" */ '../student/lesson_reservation_list_da/StudentLessonListDaPage.vue');
// import StudentLessonListDaPage from '../student/lesson_reservation_list_da/StudentLessonListDaPage.vue';
const DaStudentLessonReservationCalendarPage = () =>
  import(/* webpackChunkName: "DaStudentLessonReservationCalendarPage" */ '../student/lesson_reservation_cal_da/DaStudentLessonReservationCalendarPage.vue');
// import DaStudentLessonReservationCalendarPage from '../student/lesson_reservation_cal_da/DaStudentLessonReservationCalendarPage.vue';

const StudentLessonStatePage = () => import(/* webpackChunkName: "StudentLessonStatePage" */ '../student/lesson_state/StudentLessonStatePage.vue');
// import StudentLessonStatePage from '../student/lesson_state/StudentLessonStatePage.vue';
const StudentTransferRequestPage = () => import(/* webpackChunkName: "StudentTransferRequestPage" */ '../student/transferRequest/StudentTransferRequestPage.vue');
// import StudentTransferRequestPage from '../student/transferRequest/StudentTransferRequestPage.vue';
const StudentInfoInputComplete = () => import(/* webpackChunkName: "StudentInfoInputComplete" */ '../student/info/StudentInfoInputComplete.vue');
// import StudentInfoInputComplete from '../student/info/StudentInfoInputComplete.vue';

const StudentDailyReportPage = () => import(/* webpackChunkName: "StudentDailyReportPage" */ '../student/report/StudentDailyReportPage.vue');
// import StudentDailyReportPage from '../student/report/StudentDailyReportPage.vue';
const DaStudentDailyReportPage = () => import(/* webpackChunkName: "DaStudentDailyReportPage" */ '../student/report/DaStudentDailyReportPage.vue');
// import DaStudentDailyReportPage from '../student/report/DaStudentDailyReportPage.vue';

const StudentTermOfUsePage = () => import(/* webpackChunkName: "StudentTermOfUsePage" */ '../student/info/StudentTermOfUsePage.vue');
// import StudentTermOfUsePage from '../student/info/StudentTermOfUsePage.vue';
const StudentSettingMain = () => import(/* webpackChunkName: "StudentSettingMain" */ '../student/info/StudentSettingMain.vue');
// import StudentSettingMain from '../student/info/StudentSettingMain.vue';
const StudentPaymentReset = () => import(/* webpackChunkName: "StudentPaymentReset" */ '../student/info/StudentPaymentReset.vue');
// import StudentPaymentReset from '../student/info/StudentPaymentReset.vue';
const StudentMailRegisterPage = () => import(/* webpackChunkName: "StudentMailRegisterPage" */ '../student/register/StudentMailRegisterPage.vue');
// import StudentMailRegisterPage from '../student/register/StudentMailRegisterPage.vue';
const StudentConnectDonePage = () => import(/* webpackChunkName: "StudentConnectDonePage" */ '../student/login/StudentConnectDonePage.vue');
// import StudentConnectDonePage from '../student/login/StudentConnectDonePage.vue';
const StudentLessonStateCalendarPage = () => import(/* webpackChunkName: "StudentLessonStateCalendarPage" */ '../student/lesson_state/StudentLessonStateCalendarPage.vue');
// import StudentLessonStateCalendarPage from '../student/lesson_state/StudentLessonStateCalendarPage.vue';
const StudentMessagesPage = () => import(/* webpackChunkName: "StudentMessagesPage" */ '../student/messages/StudentMessagesPage.vue');
// import StudentMessagesPage from '../student/messages/StudentMessagesPage.vue';
const StudentPasswordChangePage = () => import(/* webpackChunkName: "StudentPasswordChangePage" */ '../student/setting/StudentPasswordChangePage.vue');
// import StudentPasswordChangePage from '../student/setting/StudentPasswordChangePage.vue';
const StudentYuuchoSettingPage = () => import(/* webpackChunkName: "StudentYuuchoSettingPage" */ '../student/info/StudentYuuchoSettingPage.vue');
// import StudentYuuchoSettingPage from '../student/info/StudentYuuchoSettingPage.vue';

export const studentRouters = [
  {
    path: '/test-user-student-login-page',
    name: 'TestUserStudentLoginPage',
    component: TestUserStudentLoginPage,
  },
  {
    path: '/student-login-page',
    name: 'StudentLoginPage',
    component: StudentLoginPage,
  },
  {
    path: '/student-line-regist-after-page',
    name: 'StudentLineRegistAfterPage',
    component: StudentLineRegistAfterPage,
  },
  {
    path: '/student-dashboard-page',
    name: 'StudentDashBoardPage',
    component: StudentDashBoardPage,
    meta: { requireAuth: true },
  },

  {
    path: '/student-info-input-main',
    name: 'StudentInfoInputMain',
    component: StudentInfoInputMain,
    meta: { requireAuth: true },
  },

  {
    path: '/student-lesson-list-page',
    name: 'StudentLessonListPage',
    component: StudentLessonListPage,
    meta: { requireAuth: true },
  },

  {
    path: '/da-student-lesson-reservation-calendar-page',
    name: 'DaStudentLessonReservationCalendarPage',
    component: DaStudentLessonReservationCalendarPage,
    meta: { requireAuth: true },
  },

  {
    path: '/student-lesson-list-da-page',
    name: 'StudentLessonListDaPage',
    component: StudentLessonListDaPage,
    meta: { requireAuth: true },
  },

  {
    path: '/student-lesson-state-page',
    name: 'StudentLessonStatePage',
    component: StudentLessonStatePage,
    meta: { requireAuth: true },
  },
  {
    path: '/student-transfer-request-page',
    name: 'StudentTransferRequestPage',
    component: StudentTransferRequestPage,
    meta: { requireAuth: true },
  },
  {
    path: '/student-daily-report-page',
    name: 'StudentDailyReportPage',
    component: StudentDailyReportPage,
    meta: { requireAuth: true },
  },
  {
    path: '/da-student-daily-report-page',
    name: 'DaStudentDailyReportPage',
    component: DaStudentDailyReportPage,
    meta: { requireAuth: true },
  },

  {
    path: '/student-info-input-complete',
    name: 'StudentInfoInputComplete',
    component: StudentInfoInputComplete,
    meta: { requireAuth: true },
  },
  {
    path: '/student-term-of-use-page',
    name: 'StudentTermOfUsePage',
    component: StudentTermOfUsePage,
    meta: { requireAuth: false },
  },
  {
    path: '/student-setting-main',
    name: 'StudentSettingMain',
    component: StudentSettingMain,
    meta: { requireAuth: true },
  },
  {
    path: '/student-payment-reset',
    name: 'StudentPaymentReset',
    component: StudentPaymentReset,
    meta: { requireAuth: true },
  },
  {
    path: '/student-mail-register-page',
    name: 'StudentMailRegisterPage',
    component: StudentMailRegisterPage,
    meta: { requireAuth: false },
  },
  {
    path: '/student-connect-done-page',
    name: 'StudentConnectDonePage',
    component: StudentConnectDonePage,
    meta: { requireAuth: false },
  },
  {
    path: '/student-lesson-state-calendar-page',
    name: 'StudentLessonStateCalendarPage',
    component: StudentLessonStateCalendarPage,
    meta: { requireAuth: true },
  },
  {
    path: '/student-messages-page',
    name: 'StudentMessagesPage',
    component: StudentMessagesPage,
    meta: { requireAuth: true },
  },
  {
    path: '/student-password-change-page',
    name: 'StudentPasswordChangePage',
    component: StudentPasswordChangePage,
    meta: { requireAuth: true },
  },
  {
    path: '/student-yuucho-setting-page',
    name: 'StudentYuuchoSettingPage',
    component: StudentYuuchoSettingPage,
    meta: { requireAuth: true },
  },
].map((route) => {
  if (!route.meta) {
    (route as any).meta = {};
  }
  (route.meta as any).type = 'student';
  return route;
});
